module.exports = __webpack_public_path__ + "img/direccion_viento_hover.6ecd06bc.png";